import { createAsyncThunk } from '@reduxjs/toolkit';

import { IntegrationClient } from '@mailingr/data-models';

import { AsyncThunkCreator } from '../../../index';
import { PRODUCT_AUTOMATION_REDUCER_NAME } from '../../productAutomation/types';

type Payload = {
  integrationId: string;
};

export const refreshGithubIntegration = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_AUTOMATION_REDUCER_NAME}/refreshGithubIntegration`,
  async (payload, { rejectWithValue, extra: { functions, analytics, auth } }) => {
    try {
      const user = auth().currentUser;
      if (!user) {
        throw new Error('User is not logged');
      }
      await functions.httpsCallable('integrations-refreshGithubIntegration')(payload);

      analytics.track('refresh_integrate_with_external_api', {
        userId: user.uid,
        email: user.email,
        integrationId: payload.integrationId,
        client: IntegrationClient.GitHub,
      });
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
